<template>
  <div>
    <div class="main-content" v-if="loader === 100">
      <div class="form-card">
        <ValidationObserver ref="formObserver" v-slot="{ invalid, validate }">
          <b-form @submit.prevent="handleSubmit(validate)" class="form-content">
            <div class="form-section">
              <ValidationProvider name="Título" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label for="titulo" class="form-label">
                    <span class="required">*</span> Título do Vídeo
                  </label>
                  <b-form-input
                      id="titulo"
                      v-model="videos.titulo"
                      :state="errors.length ? false : null"
                      placeholder="Digite o título do vídeo"
                      class="form-input"
                  />
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-section">
              <div class="form-group">
                <label for="descricao" class="form-label">Descrição</label>
                <b-form-textarea
                    id="descricao"
                    v-model="videos.descricao"
                    rows="4"
                    placeholder="Digite uma descrição para o vídeo"
                    class="form-textarea"
                />
              </div>
            </div>
            <div class="form-section">
              <div class="form-group">
                <label for="arquivo" class="form-label">
                  <span class="required">*</span> Arquivo de Vídeo
                </label>
                <div class="file-upload-container">
                  <b-form-file
                      id="arquivo"
                      accept="video/*"
                      @change="handleFileUpload"
                      ref="videoFile"
                      :state="null"
                      class="form-file"
                      placeholder="Escolha um arquivo de vídeo..."
                      browse-text="Procurar"
                  />
                  <small class="file-info">
                    <i class="fas fa-info-circle"></i>
                    Formatos aceitos: MP4, AVI, MOV, WMV (máx: 100MB)
                  </small>
                </div>
              </div>
            </div>
            <div class="form-section">
              <div class="row">
                <div class="col-md-5" v-if="videoPreview">
                  <div class="preview-container">
                    <label class="form-label">
                      {{ isEdit && videoPreview ? 'Vídeo atual:' : 'Preview do Vídeo:' }}
                    </label>
                    <video :src="videoPreview" controls class="video-preview"></video>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section">
              <div class="section-header">
                <label class="form-label">
                  <span class="required">*</span> Unidades, Painéis e Totens
                </label>

                <div style="min-width: 320px; margin-right: 12px;">
                  <label class="form-label mb-1" style="font-weight:600; font-size:12px">Grupo (opcional)</label>
                  <v-select
                      v-model="selectedGrupoId"
                      :options="allGroups"
                      :label="'label'"
                      :reduce="reduceGrupo"
                      class="form-select"
                      placeholder="Selecionar grupo"
                      @input="onGrupoInput"
                      clearable
                  />
                </div>

                <b-button variant="success" @click="addUnidade" class="btn-add-section">
                  <i class="fas fa-plus"></i> Adicionar Unidade
                </b-button>
              </div>

              <div v-if="videos.unidades.length > 0">
                <div v-for="(unitItem, unitIndex) in videos.unidades" :key="'unit-'+unitIndex"
                     class="unidade-painel-group mb-4">
                  <div class="row mb-3">
                    <div class="col-md-10">
                      <ValidationProvider name="Unidade" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                          <label class="form-label">
                            <i class="fas fa-building text-primary me-1"></i>
                            <span class="required">*</span> Unidade
                          </label>
                            <v-select
                              v-model="unitItem.unit_id"
                              :options="todasUnidades"
                              :label="'nome'"
                              :reduce="reduceUnidade"
                              class="form-select"
                              placeholder="Selecione uma unidade"
                              @input="onUnidadeChange(unitIndex, unitItem.unit_id)"
                            />
                            <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-2 d-flex align-items-end justify-content-end">
                      <b-button
                          variant="danger"
                          @click="removeUnidade(unitIndex)"
                          v-if="videos.unidades.length > 1"
                          size="sm"
                          title="Remover unidade"
                          class="btn-remove-unit"
                      >
                        <i class="fas fa-trash"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <ValidationProvider name="Painel" v-slot="{ errors }">
                        <div class="form-group">
                          <label class="form-label">
                            <i class="fas fa-tv text-info me-1"></i>
                            Painéis
                          </label>
                            <v-select
                              v-model="unitItem.paineis"
                              :options="paineisPorUnidade[unitItem.unit_id] || []"
                              :label="'nome'"
                              :reduce="reducePainel"
                              class="form-select"
                              placeholder="Selecione os painéis"
                              multiple
                            />
                          <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-6">
                      <ValidationProvider name="Totens" v-slot="{ errors }">
                        <div class="form-group">
                          <label class="form-label">
                            <i class="fas fa-desktop text-success me-1"></i>
                            Totens
                          </label>
                            <v-select
                              v-model="unitItem.totens"
                              :options="totensPorUnidade[unitItem.unit_id] || []"
                              :label="'nome'"
                              :reduce="reduceTotem"
                              class="form-select"
                              placeholder="Selecione os totens"
                              multiple
                            />
                          <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-units-message">
                <div class="no-units-icon">
                  <i class="fas fa-plus-circle"></i>
                </div>
                <p class="text-muted mb-2">Nenhuma unidade adicionada ainda.</p>
                <small class="text-muted">Clique em "Adicionar Unidade" para começar</small>
              </div>
            </div>

            <!-- Status -->
            <div class="form-section">
              <div class="row">
                <div class="col-md-4">
                  <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                    <div class="form-group">
                      <label for="status" class="form-label">
                        <span class="required">*</span> Status
                      </label>
                      <b-form-select
                          id="status"
                          v-model="videos.status"
                          :state="errors.length ? false : null"
                          class="form-select-status"
                      >
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </div>

            <!-- Rodapé -->
            <div class="form-footer">
              <div class="required-info">
                <span class="required">*</span>
                <span>Campos obrigatórios</span>
              </div>
              <div class="form-actions">
                <b-button variant="outline-secondary" class="btn-cancel" @click="$router.go(-1)">
                  <i class="fas fa-arrow-left"></i> Voltar
                </b-button>
                <b-button
                    type="submit"
                    variant="primary"
                    class="btn-save"
                    :disabled="(!videos.video && !isEdit) || isLoading"
                >
                  <template v-if="isLoading">
                    <i class="fas fa-spinner fa-spin"></i> Salvando...
                  </template>
                  <template v-else>
                    <i class="fas fa-save"></i> Salvar
                  </template>
                </b-button>
              </div>
            </div>

          </b-form>
        </ValidationObserver>
      </div>
    </div>

    <!-- Loading -->
    <div class="loading-container" v-else>
      <div class="loading-card">
        <div class="progress-container">
          <div class="progress">
            <div
                class="progress-bar"
                role="progressbar"
                :style="'width: ' + loader + '%;'"
            ></div>
          </div>
          <div class="loading-text">
            <div class="loading-title">Carregando...</div>
            <div class="loading-percentage">{{ loader }}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "axios";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {BButton, BForm, BFormFile, BFormInput, BFormInvalidFeedback, BFormSelect, BFormTextarea} from "bootstrap-vue";

export default {
  name: "videoForm",
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BFormSelect,
    BFormInvalidFeedback,
  },
  data() {
    return {
      loader: 0,
      isLoading: false,
      videos: {
        titulo: '',
        descricao: '',
        video: null,
        unidades: [{ unit_id: null, paineis: [], totens: [] }],
        status: 1,
      },
      videoPreview: null,
      todasUnidades: [],
      allGroups: [],
      selectedGrupoId: null,
      paineisPorUnidade: {},
      totensPorUnidade: {},
      isEdit: false,
      videoId: null,
    };
  },
  methods: {
        onGrupoInput(grupoId) {
          if (!grupoId) {
            this.videos.unidades = [{ unit_id: null, paineis: [], totens: [] }];
            this.paineisPorUnidade = {};
            this.totensPorUnidade = {};
            return;
          }
          this.onGrupoSelected(grupoId);
        },
    handleFileUpload(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      if (file.size > 400 * 1024 * 1024) {
        this.$message("Erro", "Arquivo muito grande (máx: 400MB).", "error");
        this.videos.video = null;
        this.videoPreview = null;
        this.$refs.videoFile.reset();
        return;
      }

      const allowedTypes = ["video/mp4", "video/avi", "video/mov", "video/wmv"];
      if (!file.type || !allowedTypes.includes(file.type)) {
        this.$message("Erro", "Formato não suportado. Aceitos: MP4, AVI, MOV, WMV.", "error");
        this.videos.video = null;
        this.videoPreview = null;
        this.$refs.videoFile.reset();
        return;
      }

      this.videos.video = file;
      this.videoPreview = URL.createObjectURL(file);
    },

    async handleSubmit(validate) {
      const isValid = await validate();
      if (!isValid) {
        return;
      }
      this.save();
    },

    buildFormData(obj) {
      const formData = new FormData();
      Object.entries(obj).forEach(([key, value]) => {
        if (key === 'unidades' && Array.isArray(value)) {
          formData.append('unidades', JSON.stringify(value));
          return;
        }
        if (key === 'video' && value instanceof File) {
          formData.append('video', value);
          return;
        }
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      return formData;
    },

    save() {
      let api = this.$store.state.api + "videos";
      let method = "post";
      if (this.isEdit) {
        api += "/" + this.videoId;
        method = "put";
      }

      const validUnits = (this.videos.unidades || [])
        .filter(unit => unit.unit_id && (
          (Array.isArray(unit.paineis_totens) && unit.paineis_totens.length) ||
          (Array.isArray(unit.paineis) && unit.paineis.length) ||
          (Array.isArray(unit.totens) && unit.totens.length)
        ))
        .map(unit => {
          if (Array.isArray(unit.paineis_totens) && unit.paineis_totens.length) {
            return {
              unit_id: unit.unit_id,
              paineis_totens: unit.paineis_totens.map(panelTotem => ({
                painel_id: panelTotem.painel_id,
                totem_id: panelTotem.totem_id,
                association_id: panelTotem.association_id || null
              }))
            };
          }

          const panels = Array.isArray(unit.paineis) ? unit.paineis : [];
          const totems = Array.isArray(unit.totens) ? unit.totens : [];
          if (panels.length && totems.length) {
            return {
              unit_id: unit.unit_id,
              paineis_totens: panels.flatMap(panelId => totems.map(totemId => {
                const key = `${unit.unit_id}_${panelId}_${totemId}`;
                const keyNullPanel = `${unit.unit_id}_null_${totemId}`;
                const keyNullTotem = `${unit.unit_id}_${panelId}_null`;
                const association_id = (this._associationMap && (this._associationMap[key] || this._associationMap[keyNullPanel] || this._associationMap[keyNullTotem])) || null;
                return {painel_id: panelId, totem_id: totemId, association_id};
              }))
            };
          }
          if (panels.length) {
            return {
              unit_id: unit.unit_id,
              paineis_totens: panels.map(panelId => ({
                painel_id: panelId,
                totem_id: null,
                association_id: (this._associationMap && this._associationMap[`${unit.unit_id}_${panelId}_null`]) || null
              }))
            };
          }
          return {
            unit_id: unit.unit_id,
            paineis_totens: totems.map(totemId => ({
              painel_id: null,
              totem_id: totemId,
              association_id: (this._associationMap && this._associationMap[`${unit.unit_id}_null_${totemId}`]) || null
            }))
          };
        });

      if (!validUnits.length) {
        this.$message("Erro", "Selecione pelo menos uma unidade com painel ou totem", "error");
        return;
      }

      const payload = {
        titulo: this.videos.titulo,
        descricao: this.videos.descricao,
        unidades: validUnits,
        status: parseInt(this.videos.status)
      };

      let dataToSend = payload;
      const config = {};
      if (this.videos.video) {
        dataToSend = this.buildFormData({...payload, video: this.videos.video});
        config.headers = {'Content-Type': 'multipart/form-data'};
        if (method === 'put') {
          dataToSend.append('_method', 'PUT');
          method = 'post';
        }
      }

      this.isLoading = true;
      axios[method](api, dataToSend, config)
        .then(() => {
          this.$message("Sucesso", "Vídeo salvo com sucesso", "success");
          this.$router.push("/videos");
        })
        .catch(error => this.handleApiErrors(error))
        .finally(() => {
          this.isLoading = false;
        });
    },

    handleApiErrors(error) {
      if (!error.response) {
        this.$message("Erro", "Erro de conexão. Verifique sua internet.", "error");
        return;
      }
      const {data, status} = error.response || {};
      if (status === 422) {
        if (data.errors) {
          const errorMessages = [];
          Object.keys(data.errors).forEach(field => {
            const fieldErrors = Array.isArray(data.errors[field]) ? data.errors[field] : [data.errors[field]];
            fieldErrors.forEach(errorMsg => errorMessages.push(`${this.getFriendlyFieldName(field)}: ${errorMsg}`));
          });
          if (errorMessages.length === 1) this.$message("Erro", errorMessages[0], "error");
          else this.$message("Erros de Validação", `${errorMessages.length} campos precisam ser corrigidos`, "error");
        } else if (data.message) {
          if (data.message.includes('já tem vídeo atrelado')) {
            const painelMatch = data.message.match(/O painel ([^j]+) já tem vídeo atrelado/);
            if (painelMatch) {
              this.$message("Erro", `O painel ${painelMatch[1].trim()} já tem vídeo atrelado`, "error");
              return;
            }
            const totemMatch = data.message.match(/O totem ([^j]+) já tem vídeo atrelado/);
            if (totemMatch) {
              this.$message("Erro", `O totem ${totemMatch[1].trim()} já tem vídeo atrelado`, "error");
              return;
            }
            this.$message("Erro", data.message, "error");
          } else this.$message("Erro", data.message, "error");
        }
        return;
      }
      if (status === 413 || (data && typeof data === 'string' && data.toLowerCase().includes('file too large'))) {
        this.$message("Erro", "Arquivo excede o limite permitido pelo servidor.", "error");
        this.videos.video = null;
        this.videoPreview = null;
        if (this.$refs.videoFile) this.$refs.videoFile.reset();
        return;
      } else if (status === 415 || (data && typeof data === 'string' && data.toLowerCase().includes('unsupported'))) {
        this.$message("Erro", "Formato de vídeo não suportado pelo servidor.", "error");
        this.videos.video = null;
        this.videoPreview = null;
        if (this.$refs.videoFile) this.$refs.videoFile.reset();
        return;
      }
      let errorMessage = "Erro ao salvar vídeo";
      if (data && data.message) errorMessage = data.message;
      else if (typeof data === 'string') errorMessage = data;
      this.$message("Erro", errorMessage, "error");
    },

    getFriendlyFieldName(field) {
      const fieldMap = {
        'titulo': 'Título',
        'descricao': 'Descrição',
        'video': 'Arquivo de Vídeo',
        'status': 'Status',
        'unidades': 'Unidades',
      };
      if (!field.includes('unidades.')) return fieldMap[field] || field;
      const parts = field.split('.');
      if (parts.length >= 4) {
        const unidadeIndex = parseInt(parts[1]) + 1;
        const itemIndex = parseInt(parts[3]) + 1;
        const subField = parts[4];
        if (subField === 'painel_id') return `Painel (${unidadeIndex}ª unidade, ${itemIndex}º item)`;
        if (subField === 'totem_id') return `Totem (${unidadeIndex}ª unidade, ${itemIndex}º item)`;
      } else if (parts.length >= 3) {
        const unidadeIndex = parseInt(parts[1]) + 1;
        const subField = parts[2];
        if (subField === 'unit_id') return `Unidade (${unidadeIndex}ª)`;
        if (subField === 'paineis_totens') return `Painéis e Totens (${unidadeIndex}ª unidade)`;
      }
      return fieldMap[field] || field;
    },

    getUnidades() {
      const api = this.$store.state.api + "unidades";
      return axios.get(api).then(response => {
        this.todasUnidades = response.data.data || response.data;
      }).catch(() => {
        this.$message("Erro", "Erro ao carregar unidades", "error");
      });
    },

    parseToId(value) {
      if (value === null || value === undefined || value === '') return null;
      if (typeof value === 'number' && !Number.isNaN(value)) return value;
      if (typeof value === 'string') {
        var m = value.match(/-?\d+/);
        return m ? Number(m[0]) : null;
      }
      if (typeof value === 'object') {
        if (value.id !== undefined) return this.parseToId(value.id);
        if (value.ID !== undefined) return this.parseToId(value.ID);
        if (value.unit_id !== undefined) return this.parseToId(value.unit_id);
        if (value.unidade_id !== undefined) return this.parseToId(value.unidade_id);
        if (value.painel_id !== undefined) return this.parseToId(value.painel_id);
        if (value.totem_id !== undefined) return this.parseToId(value.totem_id);
        if (value.painel !== undefined) return this.parseToId(value.painel);
        if (value.totem !== undefined) return this.parseToId(value.totem);
      }
      return null;
    },

    getGrupos() {
      const api = this.$store.state.api + 'grupos?paginated=false';
      return axios.get(api)
        .then(response => {
          const data = response.data.data || response.data || [];
          this.allGroups = Array.isArray(data)
            ? data.map(group => ({
                id: group.id || group.ID || group.grupo_id || group.id_grupo || group.group_id || null,
                label: group.nome || group.title || group.label || group.nome_grupo || group.name || '',
                ...group
              }))
            : [];
        })
        .catch(() => {
          this.$message('Erro', 'Erro ao carregar grupos', 'error');
          this.allGroups = [];
        });l
    },

    async fetchUnitIfMissing(unitId) {
      if ((this.todasUnidades || []).some(u => Number(u.id || u.ID || u.id_unidade || u.unidade_id) === Number(unitId))) return;
      try {
        const api = this.$store.state.api + `unidades/${unitId}`;
        const res = await axios.get(api);
        const u = (res.data && (res.data.data || res.data)) || null;
        if (!u) return;
        const unitObj = Array.isArray(u) ? u[0] : u;
        const id = unitObj.id || unitObj.ID || unitObj.unidade_id || unitObj.id_unidade || null;
        const nome = unitObj.nome || unitObj.name || unitObj.title || `Unidade ${id}`;
        this.todasUnidades.push({id, nome, raw: unitObj});
      } catch (e) {}
    },

    fetchPaineisTotensForUnit(unitId) {
      const apiPaineis = this.$store.state.api + `paineis?paginated=false&unidade_id=${unitId}`;
      const apiTotens = this.$store.state.api + `totens?paginated=false&unidade_id=${unitId}`;
      return Promise.all([
        axios.get(apiPaineis).then(r => r.data.data || r.data).then(list => this.$set(this.paineisPorUnidade, unitId, list)).catch(() => this.$set(this.paineisPorUnidade, unitId, [])),
        axios.get(apiTotens).then(r => r.data.data || r.data).then(list => this.$set(this.totensPorUnidade, unitId, list)).catch(() => this.$set(this.totensPorUnidade, unitId, []))
      ]);
    },

    async onGrupoSelected(grupoId) {
      if (!grupoId) return;
      try {
        const api = this.$store.state.api + `grupo_items?grupo_id=${grupoId}&paginated=false`;
        const response = await axios.get(api);
        const grupoItens = response.data.data || response.data || [];
        if (!Array.isArray(grupoItens) || !grupoItens.length) {
          this.$message('Aviso', 'Grupo selecionado não contém itens válidos', 'warning');
          this.selectedGrupoId = null;
          return;
        }
        const normalized = grupoItens.map(item => ({
          unidade_id: this.parseToId(item.unidade_id),
          painel_id: this.parseToId(item.painel_id),
          totem_id: this.parseToId(item.totem_id)
        })).filter(i => i.unidade_id !== null && (i.painel_id !== null || i.totem_id !== null));
        if (!normalized.length) {
          this.$message('Aviso', 'Grupo selecionado não contém itens válidos', 'warning');
          this.selectedGrupoId = null;
          return;
        }
        const paineisPorUnidade = {};
        const totensPorUnidade = {};
        normalized.forEach(item => {
          if (item.painel_id !== null) {
            if (!paineisPorUnidade[item.unidade_id]) paineisPorUnidade[item.unidade_id] = new Set();
            paineisPorUnidade[item.unidade_id].add(item.painel_id);
          }
          if (item.totem_id !== null) {
            if (!totensPorUnidade[item.unidade_id]) totensPorUnidade[item.unidade_id] = new Set();
            totensPorUnidade[item.unidade_id].add(item.totem_id);
          }
        });
        Object.keys(paineisPorUnidade).forEach(uid => {
          this.$set(this.paineisPorUnidade, uid, Array.from(paineisPorUnidade[uid]).map(id => ({ id, nome: '' })));
        });
        Object.keys(totensPorUnidade).forEach(uid => {
          this.$set(this.totensPorUnidade, uid, Array.from(totensPorUnidade[uid]).map(id => ({ id, nome: '' })));
        });
        this.applyGroupItems(normalized, { merge: true });
      } catch (e) {
        this.$message('Erro', 'Erro ao carregar itens do grupo', 'error');
      }
    },

    fetchVideo(id) {
      const api = this.$store.state.api + "videos/" + id;
      axios.get(api).then(response => {
        const video = response.data.data || response.data;
        this.videos.titulo = video.titulo || "";
        this.videos.descricao = video.descricao || "";
        this.videos.status = parseInt(video.status) || 1;
        if (video.video_url) this.videoPreview = video.video_url;

        const associations = video.videos_unidades_paineis || video.paineis_totems || video.paineisTotems || video.videos_unidades_paineis;
        if (!associations || !Array.isArray(associations)) {
          this.videos.unidades = [{unit_id: null, paineis: [], totens: []}];
          return;
        }

        const unidadesMap = {};
        this._associationMap = {};
        associations.forEach(rel => {
          const unidadeId = rel.unidade_id;
          if (!unidadesMap[unidadeId]) unidadesMap[unidadeId] = {
            unit_id: unidadeId,
            paineis: new Set(),
            totens: new Set()
          };
          const painelId = rel.painel_id || null;
          const totemId = rel.totem_id || null;
          if (painelId) unidadesMap[unidadeId].paineis.add(painelId);
          if (totemId) unidadesMap[unidadeId].totens.add(totemId);
          const key = `${unidadeId}_${painelId === null ? 'null' : painelId}_${totemId === null ? 'null' : totemId}`;
          this._associationMap[key] = rel.id || rel.ID || rel.association_id || null;
        });

        this.videos.unidades = Object.values(unidadesMap).map(unidade => ({
          unit_id: unidade.unit_id,
          paineis: Array.from(unidade.paineis),
          totens: Array.from(unidade.totens)
        }));
        this.$nextTick(() => {
          this.videos.unidades.forEach((u, idx) => {
            if (u.unit_id) this.onUnidadeChange(idx, u.unit_id, true);
          });
        });
      }).catch(() => {
        this.$message("Erro", "Erro ao carregar dados do vídeo", "error");
      });
    },

    setLoader(qtd) {
      let load = 0;
      const interval = setInterval(() => {
        if (this.loader < qtd) this.loader++;
        load++;
        if (load >= qtd) clearInterval(interval);
      }, 15);
    },

    initForm() {
      this.videoId = this.$route.params.id;
      this.isEdit = !!this.videoId;
      this.setLoader(30);
      Promise.all([this.getUnidades(), this.getGrupos()])
        .then(() => {
          if (this.isEdit) return this.fetchVideo(this.videoId);
        })
        .finally(() => {
          this.loader = 100;
        });
    },

    applyGroupItems(itens = [], options = {merge: true}) {

      if (!Array.isArray(itens) || !itens.length) return;
      const groupMap = {};
      const newAssoc = {};
      itens.forEach(rel => {
        const unitId = this.parseToId(rel.unidade_id ?? rel.unit_id);
        if (unitId === null || unitId === undefined) return;
        const uid = String(unitId);
        if (!groupMap[uid]) groupMap[uid] = { paineis: new Set(), totens: new Set() };
        const painelId = this.parseToId(rel.painel_id ?? rel.painelId);
        const totemId = this.parseToId(rel.totem_id ?? rel.totemId);
        if (painelId !== null) groupMap[uid].paineis.add(painelId);
        if (totemId !== null) groupMap[uid].totens.add(totemId);
        const key = `${uid}_${painelId === null ? 'null' : painelId}_${totemId === null ? 'null' : totemId}`;
        newAssoc[key] = rel.id || rel.ID || rel.association_id || rel.associationId || null;
      });


      const unidades = Object.keys(groupMap).map(uid => ({
        unit_id: Number(uid),
        paineis: Array.from(groupMap[uid].paineis),
        totens: Array.from(groupMap[uid].totens)
      }));

      const sanitized = unidades.map(item => ({
        unit_id: this.parseToId(item.unit_id),
        paineis: (Array.isArray(item.paineis) ? item.paineis.map(x => this.parseToId(x)).filter(n => n !== null) : []),
        totens: (Array.isArray(item.totens) ? item.totens.map(x => this.parseToId(x)).filter(n => n !== null) : [])
      })).filter(i => i.unit_id !== null);

      if (!sanitized.length) {
        this.$message('Aviso', 'Grupo selecionado não contém unidades válidas', 'warning');
      } else {
        this.videos.unidades = sanitized;
      }
      this._associationMap = this._associationMap || {};
      Object.assign(this._associationMap, newAssoc);
      this.$nextTick(() => {
        this.videos.unidades.forEach((u, idx) => {
          if (u.unit_id) this.onUnidadeChange(idx, u.unit_id, true);
        });
      });
    },

    reduceGrupo(option) {
      return option && option.id !== undefined ? option.id : option;
    },
    reduceUnidade(option) {
      return option && option.id !== undefined ? option.id : option;
    },
    reducePainel(option) {
      return option && option.id !== undefined ? option.id : option;
    },
    reduceTotem(option) {
      return option && option.id !== undefined ? option.id : option;
    },

    onUnidadeChange(index, unitId, preserveSelections = false) {
      if (!preserveSelections) this.$set(this.videos.unidades, index, {unit_id: unitId, paineis: [], totens: []});
      else this.$set(this.videos.unidades, index, {
        unit_id: unitId,
        paineis: this.videos.unidades[index] ? (this.videos.unidades[index].paineis || []) : [],
        totens: this.videos.unidades[index] ? (this.videos.unidades[index].totens || []) : []
      });

      if (!unitId) return;
      const apiPaineis = this.$store.state.api + `paineis?paginated=false&unidade_id=${unitId}`;
      const apiTotens = this.$store.state.api + `totens?paginated=false&unidade_id=${unitId}`;
      axios.get(apiPaineis).then(response => {
        this.$set(this.paineisPorUnidade, unitId, response.data.data || response.data);
      }).catch(() => {
        this.$message("Erro", "Erro ao carregar painéis da unidade", "error");
      });
      axios.get(apiTotens).then(response => {
        this.$set(this.totensPorUnidade, unitId, response.data.data || response.data);
      }).catch(() => {
        this.$message("Erro", "Erro ao carregar totens da unidade", "error");
      });
    },

    addUnidade() {
      this.videos.unidades.push({unit_id: null, paineis: [], totens: []});
    },
    removeUnidade(index) {
      if (this.videos.unidades.length > 1) this.videos.unidades.splice(index, 1); else this.$set(this.videos.unidades, 0, {
        unit_id: null,
        paineis: [],
        totens: []
      });
    },
  },

  mounted() {
    this.initForm();
  },
};
</script>

<style scoped>
.combinations-preview {
  margin-top: 20px;
  padding: 18px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  border-left: 4px solid #17a2b8;
  border-top: 1px solid #dee2e6;
}

.combinations-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.combinations-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.combination-badge {
  padding: 8px 14px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.combination-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.badge-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border: 1px solid #c3e6cb;
}

.badge-warning {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  color: #856404;
  border: 1px solid #ffeaa7;
  animation: pulse-warning 2s infinite;
}

@keyframes pulse-warning {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.combination-badge i {
  font-size: 11px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
}

.btn-add-section {
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-add-section:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(40, 167, 69, 0.3);
}

.unidade-painel-group {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 25px;
  background: #f8f9fa;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.unidade-painel-group:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.unidade-painel-group .row:first-child {
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.unidade-painel-group .row:first-child::after {
  content: '';
  position: absolute;
  left: 25px;
  right: 25px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #667eea, transparent);
  bottom: -1px;
}

.btn-remove-unit {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.3s ease;
}

.btn-remove-unit:hover {
  background: #dc3545;
  transform: scale(1.1);
  box-shadow: 0 3px 8px rgba(220, 53, 69, 0.3);
}

.form-label i {
  margin-right: 5px;
}

.no-units-message {
  text-align: center;
  padding: 60px 20px;
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transition: all 0.3s ease;
}

.no-units-message:hover {
  border-color: #667eea;
  background: linear-gradient(135deg, #f0f0ff 0%, #e6e6ff 100%);
}

.no-units-icon {
  font-size: 48px;
  color: #6c757d;
  margin-bottom: 15px;
}

.no-units-icon i {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.main-content {
  padding: 0;
  min-height: 100vh;
}

.form-card {
  border-radius: 12px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 20px;
}

.form-content {
  padding: 30px;
}

.form-section {
  margin-bottom: 30px;
}

.form-section:last-of-type {
  margin-bottom: 20px;
}

.form-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: block;
  font-size: 14px;
}

.required {
  color: #e74c3c;
  font-weight: bold;
}

.form-input, .form-textarea {
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.form-input:focus, .form-textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.15);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.file-upload-container {
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.file-upload-container:hover {
  border-color: #667eea;
}

.form-file {
  border: none;
  background: transparent;
}

.file-info {
  color: #6c757d;
  display: block;
  margin-top: 8px;
  font-size: 13px;
}

.file-info i {
  margin-right: 5px;
  color: #17a2b8;
}

.form-select {
  border-radius: 8px;
}

.form-select .vs__dropdown-toggle {
  border: none;
  padding: 10px 12px;
  min-height: 48px;
}

.form-select .vs__selected-options {
  padding: 0;
}

.form-select .vs__selected {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #2c3e50;
  font-size: 15px;
}

.form-select .vs__search {
  margin: 0;
  padding: 0;
  font-size: 15px;
}

.form-select .vs__actions {
  padding: 0 8px;
}

.form-select:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.15);
}

.form-select.is-invalid {
  border-color: #e74c3c;
}

.form-select-status {
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 15px;
  transition: all 0.3s ease;
  min-height: 48px;
  height: auto;
  box-sizing: border-box;
  width: 100%;
  display: block;
}

.form-select-status:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.15);
}

.preview-container {
  border-radius: 8px;
  padding: 20px;
}

.video-preview {
  width: 100%;
  max-height: 250px;
  border-radius: 8px;
  margin-top: 10px;
  background: #000;
}

.form-footer {
  padding: 25px 30px;
  margin: 0 -30px -30px -30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.required-info {
  color: #6c757d;
  font-size: 13px;
}

.form-actions {
  display: flex;
  gap: 12px;
}

.btn-cancel {
  background: #6c757d;
  border: none;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #5a6268;
  color: white;
  transform: translateY(-1px);
}

.btn-save {
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-save:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-save:disabled {
  background: #6c757d;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;
}

.loading-card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  min-width: 300px;
}

.progress-container {
  width: 100%;
}

.progress {
  height: 8px;
  border-radius: 20px;
  background: #e9ecef;
  overflow: hidden;
  margin-bottom: 20px;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  transition: width 0.3s ease;
}

.loading-text {
  color: #2c3e50;
}

.loading-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}

.loading-percentage {
  font-size: 24px;
  font-weight: bold;
  color: #667eea;
}

.invalid-feedback {
  color: #e74c3c;
  font-size: 13px;
  margin-top: 5px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .form-card {
    margin: 10px;
  }

  .form-content {
    padding: 20px;
  }

  .form-footer {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .form-actions {
    width: 100%;
    justify-content: center;
  }

  .section-header {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .combinations-list {
    flex-direction: column;
    gap: 8px;
  }

  .combination-badge {
    text-align: center;
    justify-content: center;
  }

  .btn-remove-unit {
    margin-top: 10px;
  }

  .unidade-painel-group {
    padding: 20px;
    margin-bottom: 20px;
  }

  .unidade-painel-group .row:first-child {
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
}
</style>
